import React from 'react';
import HeaderNews from './HeaderNews';
//import TopHead from './img/Swachhta2018.jpg';
class ChairmanMessage extends React.Component {
	render() {
		return (

			<div>
				<HeaderNews />
				<div className="pages section">
					<div className="container">
						<div className="assetsdownload">
						<div className="assetsdownload-content">

<h6 className="heading-top">Straight Talk</h6>

{/* <div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
	<div className="col">

		<img src="https://iocl.com/uploads/ioclxpress/Chairman_Messages/Straight_Talk_by_Chairman/2022/Thumb_Video_Chairman_Straight_Talk_2021.jpg" alt="IndianOil Xpress" />

	</div>

	<div className="col">
		<ul class="cl_ul" >
			<li><a class="normallink" target="_blank" href="http://iocl.com/uploads/ioclxpress/Chairman_Messages/Straight_Talk_by_Chairman/2021/Chairman_Straight_Talk_2021.mp4" download="">Video</a></li>


		</ul>
	</div>

</div> */}


<div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
	<div className="col">

		<img src="https://iocl.com/uploads/ioclxpress/Chairman_Messages/Straight_Talk_by_Chairman/2022/thumbaug22.jpg" alt="IndianOil Xpress" />

	</div>

	<div className="col">
		<ul class="cl_ul" >
			<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/straight_talk_26_aug.pdf" download="">PDF</a></li>
			<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/Straight_Talk_LQ.mp4" download="">Video</a></li>


		</ul>
	</div>

</div>




</div>
							

							
						</div>
					</div>
				</div>



				<div className="footer bottom" style={{ position: 'relative' }}>
					<div className="container">
						<div className="copyright">
							<span>Copyright © IndianOilXpress</span><br />
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
							<a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
							<a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
							<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
							<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>

						</div>
					</div>
				</div>

			</div>

		)
	}
}

export default ChairmanMessage;


// WEBPACK FOOTER //
// ./src/chairmanMessage.js